import { LoadingListEntityProfile, PaginationList } from "Explore/Components";
import styles from "./UnitScholarAndPeers.module.scss";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useRef, useState } from "react";
import { Empty } from "antd";
import { getUnitAwardedGrantsById } from "Explore/Services/Unit";
import AwardItem from "Explore/Components/AwardItem";
import { useSelector } from "react-redux";
import _ from "lodash";
import SortSelect, { SORT_TYPE } from "Explore/Components/SortSelect";

const UnitAwardList = () => {
  const { unit_id } = useExploreInfo();
  const { selectedKeywords, timeFilter } =
    useSelector((state) => state.conceptState) || {};
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [sortData, setSortData] = useState({
    orderBy: null,
    order: null,
  });

  const ref = useRef(null);
  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      })
    ) {
      let newPagination = { ...pagination };
      if (
        _prevFilter.unit_id !== unit_id ||
        _prevFilter.selectedKeywords !== selectedKeywords ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage ||
        _prevFilter.timeFilter !== timeFilter ||
        _prevFilter.orderBy !== sortData.orderBy ||
        _prevFilter.order !== sortData.order
      ) {
        newPagination.page = 1;
      }

      setData({ data: [], isLoading: true });
      getUnitAwardedGrantsById({
        id: unit_id,
        keyword: selectedKeywords,
        timeFilter,
        orderBy: sortData.orderBy,
        order: sortData.order,
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total });
        })
        .catch(() => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        })
        .finally(() => {
          ref.current.scrollIntoView({ behavior: "smooth" });
          prevFilter.current = {
            unit_id,
            selectedKeywords,
            timeFilter,
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
            orderBy: sortData.orderBy,
            order: sortData.order,
          };
        });
    } else {
      prevFilter.current = {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      };
    }
  }, [
    pagination.page,
    pagination.rowsPerPage,
    unit_id,
    selectedKeywords,
    timeFilter,
    sortData.orderBy,
    sortData.order,
  ]);

  return (
    <div ref={ref} className={styles["list__wrapper"]}>
      <SortSelect
        sortData={sortData}
        setSortData={setSortData}
        sortType={SORT_TYPE.GRANT}
        hasOrderType
        loading={data.isLoading}
      />

      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <AwardItem key={index} data={item} />;
            })
          ) : (
            <Empty description="No Grant Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <PaginationList pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default UnitAwardList;
